import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);

  if (req.url.includes(environment.backendUrl)) {
    const isRefresh = req.url.endsWith('/api/v1/authentication/refresh');

    if (isRefresh) {
      // Backend requires expired access‐token to be sent in the request headers
      const token = authenticationService.token();
      if (!token) {
        return next(req);
      }

      const newReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next(newReq);
    }

    // For all other backend calls, we first need to fetch (and possibly refresh) the access‐token:
    return from(authenticationService.fetchActiveToken()).pipe(
      switchMap((activeToken) => {
        if (!activeToken) {
          return next(req);
        }

        const newReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${activeToken}`,
          },
        });
        return next(newReq);
      }),
    );
  }

  return next(req);
};
